function Playdates() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-100 dark:from-neutral-800 dark:to-neutral-900 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-4xl w-full mx-4">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            🎾 Pet Playdates
          </h1>
          <p className="text-lg text-gray-600">
            Connect with other pet owners and schedule fun activities
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="space-y-6">
            <div className="bg-orange-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-orange-800 mb-4">
                Upcoming Playdates
              </h3>
              <div className="space-y-3">
                <div className="bg-white rounded-md p-4 border-l-4 border-orange-400">
                  <div className="flex justify-between items-start">
                    <div>
                      <h4 className="font-medium text-gray-800">Dog Park Meetup</h4>
                      <p className="text-sm text-gray-600">Riverside Park</p>
                      <p className="text-xs text-gray-500">Tomorrow at 3:00 PM</p>
                    </div>
                    <span className="text-xs bg-orange-100 text-orange-800 px-2 py-1 rounded">
                      3 pets
                    </span>
                  </div>
                </div>
                
                <div className="bg-white rounded-md p-4 border-l-4 border-blue-400">
                  <div className="flex justify-between items-start">
                    <div>
                      <h4 className="font-medium text-gray-800">Cat Cafe Social</h4>
                      <p className="text-sm text-gray-600">Downtown Cat Cafe</p>
                      <p className="text-xs text-gray-500">Saturday at 2:00 PM</p>
                    </div>
                    <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                      5 pets
                    </span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-green-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-green-800 mb-4">
                Create New Playdate
              </h3>
              <button className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200 transform hover:scale-105">
                Schedule Playdate
              </button>
            </div>
          </div>
          
          <div className="space-y-6">
            <div className="bg-purple-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-purple-800 mb-4">
                Popular Activities
              </h3>
              <div className="grid grid-cols-2 gap-3">
                <div className="text-center p-3 bg-white rounded-md">
                  <div className="text-2xl mb-1">🏃‍♂️</div>
                  <span className="text-sm">Dog Runs</span>
                </div>
                <div className="text-center p-3 bg-white rounded-md">
                  <div className="text-2xl mb-1">🎾</div>
                  <span className="text-sm">Fetch Games</span>
                </div>
                <div className="text-center p-3 bg-white rounded-md">
                  <div className="text-2xl mb-1">🏊‍♀️</div>
                  <span className="text-sm">Swimming</span>
                </div>
                <div className="text-center p-3 bg-white rounded-md">
                  <div className="text-2xl mb-1">🧘‍♀️</div>
                  <span className="text-sm">Pet Yoga</span>
                </div>
              </div>
            </div>
            
            <div className="bg-blue-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-blue-800 mb-4">
                Nearby Pet Owners
              </h3>
              <p className="text-blue-600 text-sm mb-4">
                Find pet parents in your area for spontaneous meetups
              </p>
              <div className="flex items-center space-x-2">
                <span className="w-3 h-3 bg-green-400 rounded-full"></span>
                <span className="text-sm text-gray-600">2 owners online nearby</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Playdates;